/* eslint-ignore */
// @ts-nocheck
import React, { Component } from 'react';
import { Formik, Form, Field as FormikField } from 'formik';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { IoMdArrowBack, IoMdArrowForward } from 'react-icons/io';
import api from '~/services/api';
import {
  toggleStep,
  registerContactName,
} from '../../../../../store/actions/singup-actions';
import ContainedButton from '~/components/layout/form/containedButton';
import OutlinedButton from '~/components/layout/form/outlinedButton';
import { SelectEmailContainer, FormBox, FormHeader } from './styles';
import { arrUniqueContact } from '../../../../../utils/functions';

class SignupComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emails: [],
      checkedId: null,
      contactSelected: null,
      offset: 1,
      lastPage: false,
      loading: true,
    };
  }

  componentDidMount() {
    this.requestGetEmails();
  }

  requestGetEmails = (offset = 0) => {
    const { siteId, userId } = this.props;
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('@UltragazEmpresarial:accessToken'),
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };

    api
      .get(
        `industrial/customer/v1/users/${userId}/contacts?contactType=EMAIL&site-id=${siteId}`,
        parameters
      )
      .then((res) => {
        const response = res.data;
        if (response.length !== 0) {
          const newEmails = arrUniqueContact(response);
          this.setState({
            emails: newEmails,
            loading: false,
          });
        } else {
          this.props.dispatch(toggleStep(3));
        }
      })
      .catch((err) => {
        const erro = err.response;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else if (err.response.status !== 401) {
          toast.error('Ocorreu um erro interno na aplicação');
        }
      });
  };

  handleContactChange = (contact, contactId) => {
    this.setState({ checkedId: contactId, contactSelected: contact });
  };

  selectedContact = (contact, contactId) => {
    if (!this.state.loading) {
      if ((contact, contactId)) {
        this.props.dispatch(registerContactName(contact, contactId));
        this.props.dispatch(toggleStep(2.1));
      } else {
        this.props.dispatch(toggleStep(3));
      }
    }
  };

  render() {
    const { checkedId, contactSelected } = this.state;
    return (
      <FormBox>
        <Formik
          onSubmit={() => {
            this.selectedContact(contactSelected, checkedId);
          }}
          render={({ handleChange, handleBlur, values, errors, touched }) => (
            <>
              <FormHeader>
                <h2>Selecione seu melhor e-mail</h2>
                <h3>
                  Para maior segurança, no primeiro acesso no novo portal é
                  necessário validar alguns dados cadastrais.
                </h3>
              </FormHeader>
              <Form>
                <div className="container">
                  <div className="row">
                    <h4>
                      Selecione seu principal e-mail. Será enviado um token para
                      validação do acesso.
                    </h4>
                    <SelectEmailContainer className="col-sm-12 ">
                      <div className="radio" style={{ marginBottom: 10 }}>
                        <label>
                          <input
                            type="radio"
                            value="option1"
                            onClick={() => this.handleContactChange(null, null)}
                            checked={this.state.checkedId === null}
                            style={{ marginRight: 10 }}
                          />
                          Nenhuma das opções
                        </label>
                      </div>

                      {this.state.emails.map((mails) => {
                        return (
                          <div
                            className="radio"
                            key={mails.contactId}
                            style={{ marginBottom: 10 }}
                          >
                            <label>
                              <input
                                type="radio"
                                value="option1"
                                onClick={() =>
                                  this.handleContactChange(
                                    mails.contact,
                                    mails.contactId
                                  )
                                }
                                name={mails.contactId}
                                id={mails.contactId}
                                style={{ marginRight: 10 }}
                                checked={
                                  this.state.checkedId === mails.contactId
                                }
                              />
                              {mails.contact}
                            </label>
                          </div>
                        );
                      })}
                    </SelectEmailContainer>
                  </div>
                </div>
                <div style={{ marginTop: 50 }}>
                  <ContainedButton
                    className="mb-2"
                    block
                    continue
                    type="submit"
                    icon="arrow-right"
                    text="Continuar"
                    color="#288efd"
                    name="Continuar"
                    id="Avançar"
                    width="100%"
                    loading={this.state.loading}
                    TrailingIcon={() => <IoMdArrowForward size={20} />}
                  >
                    Avançar
                  </ContainedButton>
                  <OutlinedButton
                    onClick={() => this.props.dispatch(toggleStep(1))}
                    className="mb-2"
                    block
                    outline
                    icon="arrow-left"
                    text="Voltar"
                    color="#76d2e1"
                    name="Voltar"
                    id="Voltar"
                    width="100%"
                    LeadingIcon={() => <IoMdArrowBack size={20} />}
                  >
                    Voltar
                  </OutlinedButton>
                </div>
              </Form>
            </>
          )}
        />
      </FormBox>
    );
  }
}

const mapStateToProps = (state) => ({
  url: state.signUpReducer.url,
  document: state.signUpReducer.document,
  customerCode: state.signUpReducer.customerCode,
  siteId: state.signUpReducer.siteId,
  userId: state.signUpReducer.userId,
});

export default connect(mapStateToProps)(SignupComponent);
